import { useCalendlyDialog } from '../CalendlyDialog';
import { STUDIO_SIGNUP_URL } from '../../constants';
import { trackLandingEvent } from '../../lib/analytics';
import { appendAttributionToUrl } from '../../lib/attribution';
import { normalizeCtaUrl } from '../../lib/useCaseSanity';

const BOOK_DEMO_HASH = '#book-demo';

type UseCaseCtaButtonProps = {
  label: string;
  url: string;
  variant: 'primary' | 'ghost';
};

function pagePath(): string {
  return typeof window !== 'undefined' ? window.location.pathname : '/';
}

export function UseCaseCtaButton({ label, url, variant }: UseCaseCtaButtonProps) {
  const { open: openCalendly } = useCalendlyDialog();
  const href = normalizeCtaUrl(url);
  const className = `btn btn-${variant === 'primary' ? 'primary' : 'ghost'}`;

  if (href === BOOK_DEMO_HASH || href.endsWith(BOOK_DEMO_HASH)) {
    return (
      <button
        type="button"
        className={className}
        onClick={() => {
          trackLandingEvent('generate_lead', {
            method: 'talk_to_sales',
            location: 'use_case',
            page_path: pagePath(),
          });
          openCalendly();
        }}
      >
        {label}
      </button>
    );
  }

  const isSignup = href === 'https://studio.getinduce.com' || href === STUDIO_SIGNUP_URL;
  const resolvedHref = isSignup ? appendAttributionToUrl(STUDIO_SIGNUP_URL) : href;
  const isExternal = resolvedHref.startsWith('http');

  return (
    <a
      href={resolvedHref}
      className={className}
      {...(isExternal ? { target: '_blank', rel: 'noopener noreferrer' } : {})}
      onClick={
        isSignup
          ? () => {
              trackLandingEvent('cta_signup_click', {
                location: 'use_case',
                page_path: pagePath(),
              });
            }
          : undefined
      }
    >
      {label}
    </a>
  );
}
